import React from "react";
import { AiOutlineMail } from "react-icons/ai";
import { FiFacebook, FiInstagram, FiLinkedin } from "react-icons/fi";
import { FaWhatsapp, FaTwitter, FaYoutube } from "react-icons/fa";
import { StyledFooterIconsDiv } from "../styles";
// import { useJitsu } from "@jitsu/react";

function Footer({ settings, help }) {
  // const { track } = useJitsu();
  return (
    <div
      className="fixed bottom-0 w-full bg-white shadow-inner p-4 pb-3 z-40"
      style={{ maxWidth: "420px" }}
    >
      {help && (
        <div>
          <p className="text-center text-xs">
            {Object.keys(settings).length > 0 &&
              settings.social_media_channels.help_text}
          </p>
          <StyledFooterIconsDiv
            className="flex items-center justify-center mt-3 px-5"
            primarycolor={settings["--site-widget-primary-color"]}
          >
            {settings.social_media_channels &&
              settings.social_media_channels.channels.map((channel) => {
                if (channel.enabled) {
                  return (
                    <div
                      className="border rounded-half p-2 mx-4 social-icons cursor-pointer"
                      key={channel.title}
                      // onClick={() => track(channel.icon)}
                    >
                      <a href={channel.url} target="_blank" rel="noreferrer">
                        {channel.icon === "email" ? (
                          <AiOutlineMail className="social-icon" />
                        ) : channel.icon === "facebook" ? (
                          <FiFacebook className="social-icon" />
                        ) : channel.icon === "instagram" ? (
                          <FiInstagram className="social-icon" />
                        ) : channel.icon === "linkedin" ? (
                          <FiLinkedin className="social-icon" />
                        ) : channel.icon === "whatsapp" ? (
                          <FaWhatsapp className="social-icon" />
                        ) : channel.icon === "twitter" ? (
                          <FaTwitter className="social-icon" />
                        ) : channel.icon === "youtube" ? (
                          <FaYoutube className="social-icon" />
                        ) : ""}
                      </a>
                    </div>
                  );
                }
              })}
          </StyledFooterIconsDiv>
        </div>
      )}
      <p
        className={`text-xs flex items-center justify-center font-medium ${
          help ? " mt-4" : ""
        }`}
      >
        Powered by{" "}
        <a href="https://bepragma.ai/" target="_blank">
          <img src="/pragma.svg" alt="logo" className="w-20 ml-2" />
        </a>
      </p>
    </div>
  );
}

export default Footer;
